<template>
    <div class="floating" :class="{border: border, disabled:disabled}" :style="{width: width}">
        <input @focus="$emit('focus')" class="floating__input truncate" :class="{icon: icon}" :type="type"
               placeholder="placeholder" :value="value"
               @input="$emit('input', $event.target.value)" v-on:keyup.enter="$emit('enter')" :disabled="disabled"/>
        <label class="floating__label" :class="{icon: icon}" :data-content="label"></label>
        <span v-if="icon" :class="['icon', icon]"></span>
    </div>
</template>

<script>
export default {
    name: "Input",
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        border: {
            type: Boolean,
            default: true
        },
        width: {
            type: String,
            default: '300px'
        },
        value: {
            type: [String, Number],
            default: ''
        },
        icon: String,
        type: {
            type: String,
            default: 'text'
        }
    },
}
</script>

<style lang="scss" scoped>
.floating {
    margin-bottom: 10px;
    background-color: transparent;
    transition: background-color 0.2s ease;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    position: relative;
}

.floating__input {
    padding: 1rem 0.6rem 0.4rem;
    font-size: 1rem;
    border: none;
    border-bottom: 1px solid #d0d4da;
    transition: border-color 0.2s ease;
    caret-color: #00b6ed;
    width: 100%;

}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


input.floating__input:disabled {
    background-color: rgba(255, 255, 255, 0.51);
    cursor: no-drop;
}


.border {
    .floating__input {
        padding: 1rem 0.6rem 0.4rem;
        border: 1px solid #d0d4da !important;
    }

    .floating__label::before {
        left: 11px;
    }

    span.icon {
        top: 18px;
        left: 10px;
    }

    .floating__input.icon {
        padding-left: 33px;
    }
}


.floating__input:focus-visible {
    outline: none;
}

.floating__input::placeholder {
    color: rgba(0, 0, 0, 0);
}

.floating__label {
    display: block;
    position: relative;
    max-height: 0;
    font-weight: 400;
    pointer-events: none;
}

.floating__label::before {
    color: #394956;
    content: attr(data-content);
    display: inline-block;
    filter: blur(0);
    backface-visibility: hidden;
    transform-origin: left top;
    transition: transform 0.2s ease;
    left: 10px;
    position: relative;
}

.floating__label.icon::before {
    left: 2.2rem;
}

.floating__label::after {
    bottom: 1rem;
    content: "";
    height: 0.1rem;
    position: absolute;
    transition: transform 180ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 180ms cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease;
    opacity: 0;
    left: 0;
    top: 100%;
    margin-top: -0.1rem;
    transform: scale3d(0, 1, 1);
    width: 100%;
    background-color: #00b6ed;
}

.floating__input:focus + .floating__label::after {
    transform: scale3d(1, 1, 1);
    opacity: 1;
}

.floating__input:placeholder-shown + .floating__label::before {
    transform: translate3d(0, -1.7rem, 0) scale3d(1, 1, 1);
}

.floating__label::before,
.floating__input:focus + .floating__label::before {
    transform: translate3d(0, -2.5rem, 0) scale3d(0.72, 0.72, 1);
}

.floating__input:focus + .floating__label::before, .floating__input:focus ~ span.icon {
    color: #00b6ed;
}

span.icon {
    position: absolute;
    top: 26px;
    left: 10px;
    transition: all 0.3s ease;
}

.floating__input.icon {
    padding-left: 35px
}

</style>